import { GetStaticProps } from 'next';

import {
  PrismicAllProjectsQueryDocument,
  PrismicProjectFilterQueryDocument,
  PrismicRealisationQueryDocument,
} from '@prismic/gqlTypes/prismicHooks';

import {
  PrismicAllProjectsQuery,
  PrismicAllProjectsQueryVariables,
  PrismicProjectFilterQuery,
  PrismicProjectFilterQueryVariables,
  PrismicRealisationQuery,
  PrismicRealisationQueryVariables,
} from '@prismic/gqlTypes/prismicOperations';

import { incrementalStaticRegenerationRevalidate } from '@temp/constants';
import { prismicApolloClient } from '@utils/ssg';
import { localeToPrismicQuery } from '@utils/regions';

import { generatePrismicSeo } from '@utils/seo';
import { paths } from '@temp/paths';

import { RealizationPage, RealizationPageProps } from '@temp/views/Realization';

export default RealizationPage;

export const getStaticProps: GetStaticProps<RealizationPageProps> = async ({
  locale,
  defaultLocale,
}) => {
  const { data: allProjects } = await prismicApolloClient.query<
    PrismicAllProjectsQuery,
    PrismicAllProjectsQueryVariables
  >({
    query: PrismicAllProjectsQueryDocument,
    variables: {
      ...localeToPrismicQuery(locale),
    },
  });

  const { data: projectFilters } = await prismicApolloClient.query<
    PrismicProjectFilterQuery,
    PrismicProjectFilterQueryVariables
  >({
    query: PrismicProjectFilterQueryDocument,
    variables: {
      ...localeToPrismicQuery(locale),
    },
  });

  const { data: dataSeo } = await prismicApolloClient.query<
    PrismicRealisationQuery,
    PrismicRealisationQueryVariables
  >({
    query: PrismicRealisationQueryDocument,
    variables: {
      ...localeToPrismicQuery(locale),
    },
  });

  const seo = await generatePrismicSeo(
    dataSeo?.realisation || {},
    paths.inspirations,
    'article',
    locale,
    defaultLocale
  );

  return {
    revalidate: incrementalStaticRegenerationRevalidate,
    props: {
      allProjects,
      projectFilters,
      seo,
    },
  };
};
